import React from "react";

export function SectionHeading({ children, ...rest }) {
  return <h2 {...rest}>{children}</h2>;
}

export default SectionHeading;
